function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "export",
  transform: "translate(-1.768 9.065) rotate(-45)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_62336",
  d: "M14.843,7.25h-7.7a.889.889,0,0,0,0,1.778h7.7a.889.889,0,1,0,0-1.778Z",
  transform: "translate(0.926 1.111)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_62337",
  d: "M12.767,11.508l2.37-2.37a.888.888,0,0,0,0-1.256l-2.37-2.37a.888.888,0,0,0-1.256,1.256l1.741,1.742-1.741,1.742a.888.888,0,1,0,1.256,1.256Z",
  transform: "translate(1.852 0.741)"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_62338",
  d: "M12.688,14.435a6.222,6.222,0,1,1,0-10.371.889.889,0,1,0,.984-1.482,8,8,0,1,0,0,13.334.889.889,0,1,0-.984-1.482Z",
  transform: "translate(0 0)"
}));

function SvgExport(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20.379 20.379",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExport);
export default __webpack_public_path__ + "static/media/export.dcc6c53d.svg";
export { ForwardRef as ReactComponent };